<template>
  <cs-dialog v-model="MARKETPLACE_CATEGORIES.show">
    <dialog-list-layout>
      <option-panel
        v-for="category in getPreparedCategories"
        :key="category.id"
        :option="category"
        @click="handleClick(category)"
      />
    </dialog-list-layout>
  </cs-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

import DialogListLayout from 'modules/Dialogs/ListLayout';
import OptionPanel from '@/components/capusta/OptionPanel';

export default {
  name: 'ModalMarketplaceCategories',
  components: {
    DialogListLayout,
    OptionPanel,
  },
  computed: {
    categoryCode() {
      return this.MARKETPLACE_CATEGORIES.categoryCode;
    },
    categories() {
      return this.MARKETPLACE_CATEGORIES.categories;
    },
    getPreparedCategories() {
      return this.categories.map(category => {
        return {
          id: category.id,
          code: category.code,
          description: this.$t(category.description),
          active: category.code === this.categoryCode,
        };
      });
    },
    ...mapState({
      MARKETPLACE_CATEGORIES: state => state.MODALS.MARKETPLACE_CATEGORIES,
    }),
  },
  methods: {
    close() {
      this.SET_MODAL_PARAMS({
        type: 'MARKETPLACE_CATEGORIES',
        params: {
          show: false,
          billCode: null,
          categoryCode: null,
          categories: [],
        },
      });
    },
    async handleClick(category) {
      if (category.active) {
        return;
      }

      try {
        await HTTPService.editBill(
          { marketplaceCategoryId: category.id },
          this.MARKETPLACE_CATEGORIES.billCode
        );

        this.CHANGE_SELECTED_TRANSACTION_MARKETPLACE_CATEGORY_ID(category.id);
      } catch (error) {
        logrocket.logger(error);
      }

      this.close();
    },
    ...mapMutations(['SET_MODAL_PARAMS', 'CHANGE_SELECTED_TRANSACTION_MARKETPLACE_CATEGORY_ID']),
  },
};
</script>

<style lang="sass" scoped>
  .modal-container
    width: 100%
    max-width: 100%
    height: 100%
    max-height: 100%
    display: block
    position: fixed
    top: 0
    left: 0
    overflow: overlay
    background-color: transparentize(#B979E5, .75)
    z-index: 1000

  .modal-frame
    margin: 10% 0 40px
    width: 100%
    max-width: 36rem
    position: absolute
    top: 0
    left: 50%
    transform: translate(-50%, 0%)
    overflow: auto
    transition: top .2s ease

    &.shown
      overflow: hidden

  .modal-inner-container
    max-width: 36rem
    margin: auto
    padding: 20px
    background: #181823
    border-radius: 10px

    & *
      &:not(:last-child)
        margin-bottom: 20px
</style>
